module.exports = __webpack_public_path__ + "img/Wendy Ghee Draper.88e7ce34.jpg";